module.exports = __webpack_public_path__ + "static/img/Auto Harvester_2x3.ae741480.webp";